import React, { useState, useEffect } from 'react';
import './UserList.css';
import io from 'socket.io-client';
const SOCKET_URL = "https://ubkrd.info"; // Update with your server URL
const socket = io(SOCKET_URL);

function UserList() {
  const [users, setUsers] = useState([]);
  const [user_status, setUserStatus] = useState([]);
  useEffect(() => {
    setTimeout(() => {
        socket.emit('retreive_users_data');
    }, 5000);
  }, [users]);
  useEffect(() => {
    socket.on('data_users', (userList) => {
      console.log(userList)
        setUsers(userList.result);
        setUserStatus(userList.resdata)
      });
  
    //   return () => {
    //     socket.disconnect();
    //     };
  }, [])
  const onClickBlock = (mobile_number) => {
    socket.emit("blocktheuser", {mobile_number})
  }

  return (
    <div className="user-list">
      <h1>User Session</h1>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Mobile Number</th>
            <th>Session ID</th>
            <th>Status</th>
            <th>CallerID</th>
            <th>Call Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {user_status.length ? (
          <>
          {user_status.map(user_stat => (
            <tr key={user_stat.id}>
              <td>{user_stat.id}</td>
              <td>{user_stat.mobile_number}</td>
              <td>{user_stat.session_id}</td>
              <td>{user_stat.status}</td>
              <td>{user_stat.callerId}</td>
              <td>{user_stat.callstatus ? (<>True</>):(<>False</>)}</td>
              <td>{user_stat.request_received ? (
                <button style={{width:100, background:"green"}} onClick={() => {onClickBlock(user_stat.mobile_number)}}>Remove</button>
              ):(<></>)}</td>
            </tr>
          ))}
          </>
          ):(<>Loading...</>) }
        </tbody>
      </table>
      <h1>User List</h1>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Mobile Number</th>
            <th>Signup Date</th>
            <th>Varified</th>
            <th>DID</th>
          </tr>
        </thead>
        <tbody>
          {users.length ? (
          <>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.mobile_number}</td>
              <td>{user.created_at}</td>
              <td>{user.verified ? (<>True</>):(<>False</>)}</td>
              <td>{user.did}</td>
            </tr>
          ))}
          </>
          ):(<>Loading...</>) }
        </tbody>
      </table>
    </div>
  );
}

export default UserList;
